// extracted by mini-css-extract-plugin
export default {"page":"Page_page__WDalYapV","title":"Page_title__WsW80phT"};